import { faTruckMonster } from '@fortawesome/free-solid-svg-icons';
import PieChart from "../../../assets/js/Charts/PieChart";
import BarChart from "../../../assets/js/Charts/BarChart";
import StackedBarChart from "../../../assets/js/Charts/StackedBarChart";
import apexchart from '../../../../node_modules/vue-apexcharts';

export default {
  name: "Portfolio",
  components: {
    PieChart,
    BarChart,
    StackedBarChart,
    apexchart
  },
  props: [
    "imgPath",
    "is_premium",
    "portfolioData",
    "plotPieData",
    "plotPieDataForModel",
    "plotPieDataForTop5User",
    "plotPieDataForTop5Model",
    "plotBarData",
    "plotBarDataForModel",
    "noDataMsg",
    "chartData",
    "chartDataForTop5User",
    "chartDataForTop5Model",
    "chartDataForModel",
    "barData",
    "barOptions",
    "barDataForModel",
    "barOptionsForModel",
    "stackedBarDataForInit",
    "stackedBarOptionsForInit",
    "stackedBarDataForFinal",
    "stackedBarOptionsForFinal",
    "showAlert"
  ],
  data() {
    return {
      eBreakdownByMarketcapSeries: this.chartData.datasets[0].data.map(function(item) {
        return parseFloat(item);
      }),
      modalShow: false,
      eBreakdownByMarketcapChartOptions: {
            chart: {
              type: 'donut',
            },
            dataLabels: {
              enabled: true,
              formatter: function (val, opts) {
                return opts.w.globals.series[opts.seriesIndex];
              }
            },
            legend: {
              position: 'bottom',
              inverseOrder: true,
              formatter: function(seriesName, opts) {
                let val = opts.w.globals.series[opts.seriesIndex]
                return ["<span style='display: flex; justify-content: space-between; width: 100px'>"+ seriesName,  (val ? ' <span class="legendVal"><strong>'+  (val + "%") :  '<span class="legendVal"><strong>'+val + '</span></strong>'+ "</span>")]
              }
            },
            plotOptions: {
              pie: {
                startAngle: 90,
                endAngle: -270,
                donut: {
                  labels: {
                    show: false,
                    value: {
                      show: true,
                      fontSize: '16px',
                      fontFamily: 'Helvetica, Arial, sans-serif',
                      color: undefined,
                      formatter: function (val) {
                        return val
                      }
                    },
                    total: {
                      show: true,
                      label: 'Total',
                      color: '#373d3f',
                    }
                  }
                }
              }
            },
             colors: ['#104c99', '#468fec', '#adcef9'],
            labels:["Large", "Mid", "Small"],
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 400
                },
                legend: {
                  position: 'bottom'
                }
              }
            }, {
              breakpoint: 560,
              options: {
                chart: {
                  width: 500
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
      },
      rBreakdownByMarketcapSeries: this.chartDataForModel.datasets[0].data.map(function(item) {
        return parseFloat(item);
      }),
      rBreakdownByMarketcapChartOptions: {
            chart: {
              width: 380,
              type: 'donut',
            },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.globals.series[opts.seriesIndex];
          }
        },
            legend: {
              position: 'bottom',
              inverseOrder: true,
              formatter: function(seriesName, opts) {
                let val = opts.w.globals.series[opts.seriesIndex]
                return ["<span style='display: flex; justify-content: space-between; width: 100px'>"+ seriesName,  (val ? ' <span class="legendVal"><strong>'+  (val + "%") :  '<span class="legendVal"><strong>'+val + '</span></strong>'+ "</span>")]
              }
            },
            plotOptions: {
              pie: {
                startAngle: 90,
                endAngle: -270,
                donut: {
                  labels: {
                    show: false,
                    value: {
                      show: true,
                      fontSize: '16px',
                      fontFamily: 'Helvetica, Arial, sans-serif',
                      color: undefined,
                      offsetY: 16,
                      formatter: function (val) {
                        return val
                      }
                    },
                    total: {
                      show: true,
                      label: 'Total',
                      color: '#373d3f',
                    }
                  }
                }
              }
            },
            colors: ['#104c99', '#468fec', '#adcef9'],
            labels:["Large", "Mid", "Small"],
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 400
                },
                legend: {
                  position: 'bottom'
                }
              }
            },
              {
                breakpoint: 560,
                options: {
                  chart: {
                    width: 500
                  },
                  legend: {
                    position: 'bottom'
                  }
                }
              }]
      },
      eHoldingsSeries: [{
        data: this.barData.datasets[0].data.map(function(item) {
          return parseFloat(item);
        }).filter(cv => cv != "0")
      }],
      eHoldingsChartOptions: {
        chart: {
          height: 250 ,
          type: 'bar',
          toolbar: {
            show: false,
            tools: {
              download: false,
            },
          },
        },
        legend: {
          show: false,
        },
        plotOptions: {
          bar: {
           distributed: true,
                horizontal: true,
                barHeight: '75%',
          }
        },

        dataLabels: {
          enabled: faTruckMonster,
          style: {
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: '600',
            colors: ['#ffffff'],
          },
        },
        xaxis: {
          categories: this.barData.labels,
          labels: {
            style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-label',
            },
          }
        },
        yaxis: {
          labels: {
            style: {
                colors: [],
                fontSize: '13px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-label',
            },
          }
        }
      },
      rHoldingsSeries: [{
        data: this.barDataForModel.datasets[0].data.map(function(item) {
          return parseFloat(item);
        }).filter(cv => cv != "0")
      }],
      rHoldingsChartOptions: {
        chart: {
          type: 'bar',
          height: 250,
          toolbar: {
            show: false,
            tools: {
              download: false,
            },
          },
        },
        legend: {
          show: false,
        },
        plotOptions: {
          bar: {
            borderRadius: 0,
            horizontal: true,
            distributed: true
          }
        },
        dataLabels: {
          enabled: faTruckMonster,
          style: {
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: '600',
            colors: ['#ffffff'],
          },
        },
        xaxis: {
          categories: this.barDataForModel.labels,
          labels: {
            style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-label',
            },
          }
        },
        yaxis: {
          labels: {
            style: {
                colors: [],
                fontSize: '13px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-label',
            },
          }
        }
      },
      //Top 5 allocation
      eAllocationSeries: this.chartDataForTop5User.datasets[0].data.map(function(item) {
        return parseFloat(item);
      }),
      eAllocationChartOptions: {
            chart: {
              width: 480,
              type: 'pie',
            },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.globals.series[opts.seriesIndex];
          }
        },
            legend: {
              position: 'bottom',
              fontSize: '14px',
              itemMargin: {
                horizontal: 0, vertical: 10
              },
              formatter: function(seriesName, opts) {
                let val = opts.w.globals.series[opts.seriesIndex]
                return ["<span >"+ seriesName,  (val ? ' <span class="legendVal"><strong>'+  (val + "%") :  '<span class="legendVal" style="padding-left:10px"><strong >'+ val + '</span></strong>'+ "</span>")]
              }
            },

            plotOptions: {
              pie: {
                startAngle: 90,
                endAngle: -270,
                donut: {
                  labels: {
                    show: false,
                    value: {
                      show: true,
                      fontSize: '16px',
                      fontFamily: 'Helvetica, Arial, sans-serif',
                      color: undefined,
                      offsetY: 16,
                      formatter: function (val) {
                        return val
                      }
                    },
                    total: {
                      show: true,
                      label: 'Total',
                      color: '#373d3f',
                    }
                  }
                }
              }
            },

            labels:this.chartDataForTop5User.labels,
            colors: ['#104c99', '#00e396', '#feb019', '#ff4560', '#775dd0'],
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 500
                },

              }
            }]
      },
      rAllocationSeries: this.chartDataForTop5Model.datasets[0].data.map(function(item) {
        return parseFloat(item);
      }),
      rAllocationChartOptions: {
            chart: {
              width: 480,
            },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.globals.series[opts.seriesIndex];
          }
        },
            legend: {
              position: 'bottom',
              fontSize: '14px',
              itemMargin: {
                horizontal: 0, vertical: 10
              },
              formatter: function(seriesName, opts) {
                let val = opts.w.globals.series[opts.seriesIndex]
                return ["<span>"+ seriesName,  (val ? ' <span class="legendVal"><strong>'+  (val + "%") :  '<span class="legendVal"><strong>'+val + '</span></strong>'+ "</span>")]
              }
            },

            plotOptions: {
              pie: {
                startAngle: 90,
                endAngle: -270,
                donut: {
                  labels: {
                    show: false,
                    value: {
                      show: true,
                      fontSize: '16px',
                      fontFamily: 'Helvetica, Arial, sans-serif',
                      color: undefined,
                      offsetY: 16,
                      formatter: function (val) {
                        return val
                      }
                    },
                    total: {
                      show: true,
                      label: 'Total',
                      color: '#373d3f',
                    }
                  }
                }
              }
            },

            labels:this.chartDataForTop5Model.labels,
            colors: ['#104c99', '#00e396', '#feb019', '#ff4560', '#775dd0'],
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 500
                },

              }
            }]
      },
      eCashSeries: [{
        name: 'Cash',
        data: [this.stackedBarDataForInit.datasets[0].data[0]]
      }, {
        name: 'Equity',
        data:  [this.stackedBarDataForInit.datasets[1].data[0]]
      }],
      eCashChartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: false,
            tools: {
              download: false,
            },
          },
        },
        legend: {
          position: 'bottom'
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        colors: ['#104c99', '#468fec'],
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        title: {
          text: ''
        },
        xaxis: {
          categories: ["Cash vs Equity"],
          labels: {
            style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-label',
            },
          }
        },
        yaxis: {
          labels: {
            style: {
                colors: [],
                fontSize: '13px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-label',
            },
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "%"
            }
          }
        },
        fill: {
          opacity: 1

        }
      },
      rCashSeries: [{
        name: 'Cash',
        data: [this.stackedBarDataForFinal.datasets[0].data[0]]
      }, {
        name: 'Equity',
        data:  [this.stackedBarDataForFinal.datasets[1].data[0]]
      }],
      rCashChartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: false,
            tools: {
              download: false,
            },
          },
        },
        legend: {
          position: 'bottom'
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        colors: ['#104c99', '#468fec'],
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        title: {
          text: ''
        },
        xaxis: {
          categories: ["Cash vs Equity"],
          labels: {
            style: {
                colors: [],
                fontSize: '12px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-label',
            },
          }
        },
        yaxis: {
          labels: {
            style: {
                colors: [],
                fontSize: '13px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600,
                cssClass: 'apexcharts-xaxis-label',
            },
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "%"
            }
          }
        },
        fill: {
          opacity: 1

        },
      },

    }
  },
  computed: {
    isARGuest() {
      return localStorage.getItem('userType') == 3? true:false;
    }
  },
  methods: {

    getTwoFixedVal(value) {
      if (
        isNaN(value) ||
        value == 0 ||
        value == "-" ||
        value == null ||
        value == ""
      ) {
        return "-";
      } else {
        return parseFloat(value).toFixed(2);
      }
    },

    redirecttoplanpage(){
      this.$router.push('plandetails')
    },

    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
  }
};




// WEBPACK FOOTER //
// ./src/assets/js/Report/ExistingRestructured.js